export const IS_DEV = process.env.NODE_ENV === 'development';

export const IS_PRD = process.env.NODE_ENV === 'production';
